import { useTranslation } from "react-i18next";
import { useState } from "react";
import "./AutoSearchForm.scss";

/**
 *
 * @param {*} props
 * @returns
 */
export default function AutoSearchForm(props) {
  const { t } = useTranslation();

  const [contactName, setContactName] = useState(
    props?.currState?.contactName ? props?.currState?.contactName : ""
  );

  return (
    <>
      <div className="formContainer">
        <div className="policyData">
          <div className="policyHeader driverContainer">
            <h4 className="driver-header">Welcome, {contactName}</h4>
            <h6 className="driver-header driver-header-reminder">
              If this is not you, click <b style={{ color: "black" }}>Not Me</b>
              , or click <b style={{ color: "black" }}>Continue</b> to proceed.
            </h6>
          </div>
        </div>
      </div>
    </>
  );
}
